import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../services/client";
import { ENDPOINTS } from "../../config";

// Thunk to export vendor data
export const exportAllVendorData = createAsyncThunk(
  "exportAll/exportAllVendorData",
  async (emailList, thunkAPI) => {
    try {
      const response = await client.post(ENDPOINTS.vendorExportAll, emailList);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

// Initial state
const initialState = {
  exportData: null,
  status: "idle", // idle / loading / succeeded / failed
  error: null,
};

// Slice for vendor export
const exportAllSlice = createSlice({
  name: "exportAll",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(exportAllVendorData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(exportAllVendorData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.exportData = action.payload;
      })
      .addCase(exportAllVendorData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Something went wrong";
      });
  },
});

export default exportAllSlice.reducer;
